import type { FaireProductEntity } from "../../entity_types/product";

export const p_6umfyrmazt: FaireProductEntity = {
  token: "p_6umfyrmazt",
  type: "product",
  name: "Canvas Tote, Library Card (Pink)",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl:
    "https://cdn.faire.com/fastly/63d13856f38fcd7ab86d3953a24cf57686d2ea50e377053dc95c0dc235ca1999.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a45a0cccae173c189bf03af51302bbd694519f247e709440977c5128462beef.jpeg",
    "https://cdn.faire.com/fastly/6ea682b8e869acf791fa5e6cc8ef44cdacababb61fb1d015091fdc198abb2a31.jpeg",
    "https://cdn.faire.com/fastly/9ea4f01999203038472e31c2883447b03a04d25dd68a9e5ae04b96b58e3ecca7.jpeg",
  ],
  priceDollars: 14.52,
  description:
    "You have a statement to make, and it’s definitely about library cards. This cool canvas tote features a double-sided design and an interior pocket, making it the perfect companion for bookstore trips, library hauls, study sessions, and everyday errands. Cute, functional, and proudly bookish.\n\nFeatures\n\nDurable canvas tote with a bold library card–inspired design\n\nDouble-sided artwork for extra visual appeal\n\nIncludes an interior pocket for keys, pens, or small essentials\n\nRoomy and comfortable to carry\n\nDesigned in Bando’s signature bright, playful style\n\n\nIdeal For\n\nGift shops and bookstores\n\nLifestyle, stationery, and library retailers\n\nStudents, readers, and literary enthusiasts\n\nWholesale buyers seeking cute, functional totes with bookish flair",
  tags: [],
  msrpDollars: 29.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:43.326Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
